import { render, staticRenderFns } from "./AllowToken.vue?vue&type=template&id=27bf286c&scoped=true&"
import script from "./AllowToken.vue?vue&type=script&lang=js&"
export * from "./AllowToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf286c",
  null
  
)

export default component.exports